const RECORDER_MIME_CANDIDATES = [
  'audio/webm',
  'audio/mp4',
  'audio/ogg'
] as const

export default function getSupportedRecorderMimeType(): string {
  if (typeof MediaRecorder === 'undefined') {
    return RECORDER_MIME_CANDIDATES[0]
  }

  for (const mimeType of RECORDER_MIME_CANDIDATES) {
    if (MediaRecorder.isTypeSupported(mimeType)) {
      return mimeType
    }
  }

  return RECORDER_MIME_CANDIDATES[0]
}
